export default "__VITE_ASSET__BMwGR6Wn__"